module.exports = __webpack_public_path__ + "static/food-water-logo-54dffc1efa42acb6e93d516c120f4bc0.png";